import { useParams } from 'react-router-dom';
import { resolveState } from '@/lib/usStates';
import { resolveMetro } from '@/lib/usMetros';
import InstructorsByStatePage from '@/pages/public/InstructorsByStatePage';
import InstructorsByCityPage from '@/pages/public/InstructorsByCityPage';

/**
 * Dispatcher for `/instructors/:slug` — picks city hub vs state hub
 * based on the slug. Unknown slugs fall through to the state-hub
 * component which then redirects to `/instructors`.
 *
 * Order matters: try metro first because some city slugs end in a
 * state code (e.g. `washington-dc`) and could conflict with state
 * resolution if the order were flipped.
 */
export default function InstructorSlugRouter() {
  const { state } = useParams();
  if (resolveMetro(state || '')) return <InstructorsByCityPage />;
  return <InstructorsByStatePage />;
}
